module.exports = __webpack_public_path__ + "static/media/icon-permanent-note.bc4443cf.svg";